import { LeftOutlined, SearchOutlined, PlusCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import JobPostingCard from "./card/JobPostingCard";
import JobTimeline from "./card/JobTimeline";
import JobTimelineDrawer from "./card/JobTimelineDrawer";
import { Pagination, Input, Select, Button, Spin, Empty } from "antd";
import { useState, useEffect } from "react";
import { useJobOpenings } from "../../app/hooks/useJobOpenings";
import { PaginatedResult } from "../../app/utils/pagination";
import Debounce from "../../app/utils/debounce";
import { toast } from "react-toastify";

const debouncer = new Debounce();

const { Option } = Select;

const JobOpeningBody = () => {
  const navigate = useNavigate();
  const [panelVisible, setPanelVisible] = useState(false);
  const [selectedJobOpeningId, setselectedJobOpeningId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [employmentType, setEmploymentType] = useState();
  const [paginatedResult, setPaginatedResult] = useState(new PaginatedResult());
  const [isLoading, setIsLoading] = useState(false);
  const pageSize = 9;

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    debouncer.debounce({
      debounce: () => {
        setCurrentPage(1);
        setDebouncedSearch(value);
      },
      debounceTimeout: 800,
    });
  };

  const { getPagination } = useJobOpenings({
    pageNumber: currentPage,
    pageSize: pageSize,
    search: debouncedSearch,
    type: employmentType,
  });

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const result = await getPagination();
        setPaginatedResult(result);
      } catch (error) {
        toast.error(error, {
          position: "top-right",
        });
        setPaginatedResult(new PaginatedResult());
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [currentPage, pageSize, debouncedSearch, employmentType]);

  const showPanel = (id) => {
    setselectedJobOpeningId(id);
    setPanelVisible(true);
  };

  const onClose = () => {
    setPanelVisible(false);
  };

  const handleEditClick = (id) => {
    navigate(`/recruitment/post-job-opening/${id}`);
  };

  const handleTypeChange = (value) => {
    setEmploymentType(value);
    setCurrentPage(1);
  };

  return (
    <div className="flex flex-col">
      <div className="flex items-center">
        <LeftOutlined
          onClick={() => navigate(`/recruitment`)}
          className="cursor-pointer inline-flex items-center justify-center p-2 rounded-full transition-all duration-200 hover:border hover:border-gray-300 hover:shadow-md"
          style={{ fontSize: "35px" }}
        />
        <h2 className="text-3xl p-0 m-0 font-semibold ml-4">Recent Job Post</h2>
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:gap-8 items-end mt-6">
        <div className="flex flex-col md:flex-row gap-4 flex-1">
          <Input
            size="large"
            placeholder="Search here"
            value={searchText}
            onChange={handleSearchChange}
            prefix={<SearchOutlined style={{ fontSize: "25px", color: "#666" }} />}
          />
          <Select size="large" placeholder="Any classification" className="w-full md:w-64" value={employmentType} onChange={handleTypeChange}>
            <Option value="all">All</Option>
            <Option value="Core">Core</Option>
            <Option value="ProjectBased">Project-Based</Option>
          </Select>
        </div>
        <Button
          type="primary"
          style={{ backgroundColor: "#F97316", borderColor: "#F97316" }}
          onClick={() => navigate(`/recruitment/post-job-opening`)}
          className="hover:shadow-lg flex items-center rounded-2xl text-xl font-bold py-8 px-6 h-12 gap-2"
        >
          <PlusCircleFilled style={{ fontSize: "30px" }} />
          POST JOB POSTING
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-8 flex-grow">
        {isLoading ? (
          <div className="col-span-3 flex justify-center py-20">
            <Spin tip="Fetching Job Openings..." />
          </div>
        ) : paginatedResult.data?.length > 0 ? (
          paginatedResult.data.map((job) => (
            <JobPostingCard key={job.id || job._id} job={job} onInfoClick={() => showPanel(job.id)} onCardClick={() => handleEditClick(job.id)} />
          ))
        ) : (
          <div className="col-span-3 py-20">
            <Empty description="No job postings found." />
          </div>
        )}
      </div>

      <div className="flex justify-center mb-4">
        <div className="flex justify-center mb-4">
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            className="job-search-pagination"
            total={paginatedResult.totalItems}
            onChange={(page) => {
              setCurrentPage(page);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            showSizeChanger={false}
          />
        </div>
      </div>

      <JobTimelineDrawer isOpen={panelVisible} onClose={onClose}>
        <JobTimeline jobId={selectedJobOpeningId} />
      </JobTimelineDrawer>
    </div>
  );
};

export default JobOpeningBody;
